// extracted by mini-css-extract-plugin
export default {"Gifts":"Gifts_Gifts__palIO"};